import MomentUtils from "@date-io/moment";
import { Button, CircularProgress, Fade, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Paper, Select, Table, TableBody, TableCell, TableRow, Typography, withStyles, ListItemText, Fab, Icon } from "@material-ui/core";
import { blue, red } from '@material-ui/core/colors';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import React, { Component } from "react";
import 'react-day-picker/lib/style.css';
import EnhancedTableHead from "../components/EnhancedTableHead";
import EnhancedTableToolbar from "../components/EnhancedTableToolbar";
import "../css/inventory_transactions.css";
import { ProductService } from "../Services/ProductService";
import { WarehouseService } from "../Services/WarehouseService";
import { format_without_time, format_fancy_notime } from '../Utils';
import XLSX from 'xlsx';
import VerifyPhysicalStockDialog from "../components/VerifyPhysicalStockDialog";

const styles = theme =>({
    appBar: {
        position: 'relative',
        marginBottom: 10
    },

    fab: {
        margin: theme.spacing(1),
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        position: 'fixed', 
        zIndex: 2
    },
    
    root: {
        width: '100%',
        overflowX: 'auto',
        paddingTop : theme.spacing(1), 
        paddingLeft: theme.spacing(1), 
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    qtyField: {
        width: "40%",
        position: "relative",
        [theme.breakpoints.up('md')]: {
            right: '100px',
            width: "10%",
            marginRight: 10
        },
        right: "22px"
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
        textAlign: 'center',
        color: theme.palette.text.secondary,
        marginBottom : '20px',
    },
    grid: {
        [theme.breakpoints.up('md')]: {
            marginTop: '10px',
        },
        marginTop: '50px',
        marginBottom: '5px'
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    icon: {
        padding: '0px',
        [theme.breakpoints.up('md')]: {
            padding: '12px',
        },
    },
    txn_details: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        float: "right",
        marginRight: theme.spacing(4)
    },
    formControl: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(2),
        },
    },
    formControlLeft: {
        margin: theme.spacing(1),
        marginTop: theme.spacing(3),
        minWidth: 200,
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(4),
        },
    },
    card: {
        maxWidth: 600,
        minWidth: 300,
        minHeight: 184,
        margin: 5
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    tablecell: {
        fontSize: '12pt',
        padding: theme.spacing(2)
    },
    container: {
        paddingTop : theme.spacing(1)
    },
    redAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: red[500],
    },
    blueAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: blue[500],
    },
    formControlAutoComplete: {
        zIndex: 2,
        margin: theme.spacing(1),
        minWidth: 200,
        [theme.breakpoints.up('md')]: {
            marginLeft: theme.spacing(1),
        },
    },
    row: {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.background.default,
        },
    },
    instructions: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(3),
        marginBottom: theme.spacing(1),
    },
    button: {
        marginTop: theme.spacing(3),
        height: theme.spacing(7),
        float: 'left',
        marginLeft: theme.spacing(2),
    }, 
    tableWrapper: {
        height: 407,
        overflow: 'auto',
    },
    list: {
        width: '100%',
        height: 250,
        overflow: "auto"
    },
    summary: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    typography: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    details: {
        alignItems: 'center',
    },
    columnFilter: {
        marginTop: 5,
        flexBasis: '5%',
    },
    column: {
        flexBasis: '100%',
    },
    helper: {
        borderLeft: `2px solid ${theme.palette.divider}`,
        padding: theme.spacing(1, 2),
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    heading: {
        fontSize: theme.typography.pxToRem(18),
    }
});

class VerifyPhysicalStockReport extends Component {

    constructor(props) {
      super(props);
      this.state = {
        startdate : moment().startOf('day'),
        current_rows: [],
        columns : [
            { id: 'index', numeric: false, disablePadding: true, label: '', sortable: false },
            { id: 'product_name', numeric: false, disablePadding: true, label: 'Product', sortable: false },
            { id: 'actual_qty', numeric: true, disablePadding: true, label: 'Current Stock', sortable: false  },
            { id: 'physical_qty', numeric: true, disablePadding: true, label: 'Physical Stock', sortable: false  },
            { id: 'original_diff', numeric: true, disablePadding: true, label: 'Original Difference', sortable: false  },
            { id: 'diff', numeric: true, disablePadding: true, label: 'Current Difference', sortable: false  },
        ],
        order: "asc",
        orderBy: "product_name",
        master_products: [],
        master_source: [],
        selected_source: "",
        loading: false,
        selected_stock_type: "FRESH",
        master_stock_type: [{id: 'FRESH',name: 'FRESH'}, {id: 'RETURN', name: 'RETURN'}],
        exporting: false,
        new_dialog_open: false,
        stock_type_rows: [],
        source_names: []
      }
    }

    componentDidMount(){
        this.props.setTitle('Physical Stock Mismatch Report');
        this.fetchStockTypeFilter();
        this.fetchMasterData();
    }

    fetchMasterData = () => {
        this.fetchProducts();
        this.fetchSourcesFilter();
    }

    fetchStockTypeFilter = () => {
        let stock_type_rows = this.state.master_stock_type.map((type) => (
            <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>
        ));
        this.setState({stock_type_rows});
    }

    handleStockTypeSelection = (e) => {
        this.setState({selected_stock_type: e.target.value}, () => this.fetchData(0, this.state.numItemsPerPage));
    }

    fetchProducts = () => {
        ProductService.getProductList()
        .then((data) => {
            this.setState({master_products: data.products});
        })
        .catch(error => {
            console.log(error);
            
        });
    }

    fetchSourcesFilter = () => {
        WarehouseService.getWarehouseList(0, 999, "", "name", "asc")
        .then((data) => {
            console.log(data);
            let source_names = [];
            let master_source = [];
            if(data && data.warehouse.length > 0){
                source_names = source_names.concat(data.warehouse.map((w) => (
                    <MenuItem key={w.id} value={w.id}>{w.name}</MenuItem>
                )));
                master_source = master_source.concat(data.warehouse);
            }
            this.setState({master_source, source_names, selected_source : ""});  
        })
        .catch(error => {
            console.log(error);
            
        });
    }

    handleSourceSelection = (e) => {
        this.setState({selected_source: e.target.value, current_rows: []});
    }

    generateReport = (e) => {
        this.fetchData();
    }

    handleChangeStartDate = (date) => {
        console.log(date);
        this.setState({
            startdate: date,
        });
    }

    exportReport = (e) => {
        let { current_rows, startdate, master_source, selected_stock_type, selected_source, master_products } = this.state;
        if(current_rows.length > 0){
            this.setState({exporting: true});

            let source_id = selected_source === "-1" ? null : selected_source;

            Promise.all([WarehouseService.getInventoryMismatchReport(moment(startdate).format(format_without_time), selected_stock_type, source_id),  WarehouseService.getStock(source_id)])
            .then((data) => {
                console.log(data);
                let mismatch_data = [];
                let stock_data = [];
                if(data[0] && data[0].report.length > 0){
                    mismatch_data = data[0].report;
                }
                if(data[1] && data[1].stock.length > 0){
                    stock_data = data[1].stock;
                }
                const wb = XLSX.utils.book_new();
                let sheetname = "Mismatch Report";
                let source = master_source.filter((m) => m.id === selected_source)[0];
                let exportData = [["Warehouse", source.name, "Stock Type", selected_stock_type, "Date", moment(startdate).format(format_fancy_notime)]];
                exportData.push([]);
                exportData.push(['Sl.no', 'Product', 'Current Stock', 'Physical Stock', 'Original Difference', 'Current Difference']);
                master_products.forEach((product, index)=> {
                    let mis = mismatch_data.filter(m => m.product_id === product.id);
                    let stock = stock_data.filter(m => m.product_id === product.id && m.stock_type === selected_stock_type);
                    mis = mis.length === 1 ? mis[0] : {};
                    stock = stock.length === 1 ? stock[0] : {};
                    let r = [ index + 1, product.name, mis.actual_qty || 0, mis.physical_qty || 0, mis.original_difference || 0, (stock.qty || 0) - (mis.physical_qty || 0)];
                    exportData.push(r);
                });

                const wsAll = XLSX.utils.aoa_to_sheet(exportData);
                XLSX.utils.book_append_sheet(wb, wsAll, sheetname );
                XLSX.writeFile(wb, `Inventory Mismatch Warehouse ${source.name}.xlsx`);
                
                this.setState({exporting: false});
            })
            .catch(error => {
                console.log(error);
                this.setState({exporting: false});
            });
        }
    } 

    fetchData = () => {
        this.setState({loading: true});
        let { startdate, selected_stock_type, selected_source, master_products } = this.state;

        let source_id = selected_source === "-1" ? null : selected_source;

        Promise.all([WarehouseService.getInventoryMismatchReport(moment(startdate).format(format_without_time), selected_stock_type, source_id),  WarehouseService.getStock(source_id)])
        .then((data) => {
            console.log(data);
            let mismatch_data = [];
            let stock_data = [];
            let current_rows = [];
            if(data[0] && data[0].report.length > 0){
                mismatch_data = data[0].report;
            }
            if(data[1] && data[1].stock.length > 0){
                stock_data = data[1].stock;
            }
            master_products.forEach((product, index)=> {
                let mis = mismatch_data.filter(m => m.product_id === product.id);
                let stock = stock_data.filter(m => m.product_id === product.id && m.stock_type === selected_stock_type);
                mis = mis.length === 1 ? mis[0] : {};
                stock = stock.length === 1 ? stock[0] : {};
                current_rows.push(<Details key={index} product={product} index={index+1} actual_qty={mis.actual_qty || 0} physical_qty={mis.physical_qty || 0} original_difference={mis.original_difference || 0} current_stock={stock.qty || 0}/>)
            })
            
            this.setState({loading: false, current_rows});
        })
        .catch(error => {
            console.log(error);
            this.setState({loading: false});
        });
    }

    newReport = (e) => {
        if(e) {
            e.preventDefault();
        }
        // this.fetchExistingTransactions();
        this.handleShow();
    }

    handleShow = () => {
        this.setState({ new_dialog_open: true});
    }
    
    render() {
        let classes = this.props.classes;
        let { loading, startdate, enddate, selected_stock_type, stock_type_rows, source_names, master_products, selected_source, exporting, new_dialog_open } = this.state;
        return (
                <div className="Home" style={{marginTop: 32}}>
                    <Fade
                        in={loading}
                        style={{
                            transitionDelay: loading ? '10ms' : '0ms'
                        }}
                        unmountOnExit
                        >
                        <CircularProgress style={{position: "fixed", top: "50%", left: "50%", zIndex: 10}}/>
                    </Fade>
                    <div>
                        <div style={{marginBottom: 80}}>
                            <Paper className={classes.root} style={{width: "100%", paddingLeft: "5px", paddingRight: "5px"}}>
                                <Grid container alignItems="flex-end" justify="flex-start">
                                    <Grid item xs={12} lg={2}  style={{zIndex: 5}}>
                                        <FormControl variant="outlined" className={classes.formControl} style={{ float: "left"}}>
                                            <InputLabel
                                                ref={ref => {
                                                this.InputLabelRef = ref;
                                                }}
                                                htmlFor="outlined-warehouse-simple"
                                            >
                                                Warehouse
                                            </InputLabel>
                                            <Select
                                                value={this.state.selected_source}
                                                onChange={this.handleSourceSelection}
                                                input={
                                                <OutlinedInput
                                                    labelWidth={50}
                                                    name="Warehouse"
                                                    id="outlined-source-simple"
                                                />
                                                }
                                            >
                                                {source_names}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <FormControl variant="outlined" className={classes.formControl} style={{ float: "left" }}>
                                            <InputLabel
                                                htmlFor="outlined-txn_type-simple"
                                            >
                                                Stock Type
                                            </InputLabel>
                                            <Select
                                                value={selected_stock_type}
                                                onChange={this.handleStockTypeSelection}
                                                input={
                                                <OutlinedInput
                                                    labelWidth={50}
                                                    name="Stock Type"
                                                    id="outlined-txn_type-simple"
                                                />
                                                }
                                            >
                                                {stock_type_rows}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <MuiPickersUtilsProvider utils={MomentUtils}>
                                            <DatePicker
                                                disableToolbar
                                                variant="dialog"
                                                inputVariant="outlined"
                                                margin="normal"
                                                label="Date"
                                                value={startdate}
                                                onChange={this.handleChangeStartDate}
                                                format='DD MMM YYYY'
                                                maxDate={enddate}
                                                className={classes.formControl}
                                                style={{float: "left"}}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Grid>
                                    <Grid item xs={12} lg={2}>
                                        <Button 
                                            disabled={!selected_source}
                                            variant="contained" 
                                            size="large" 
                                            color="primary" 
                                            style={{marginBottom: 16}}
                                            onClick={this.generateReport}>Generate Report</Button>
                                    </Grid>
                                </Grid>
                                <EnhancedTableToolbar title={""} exportReport={this.exportReport} showProgress={exporting}/>
                                <div className={classes.tableWrapper}>
                                    <Table className={classes.table} stickyHeader style={{textAlign: 'justify'}}>
                                        <EnhancedTableHead
                                            order={this.state.order}
                                            orderBy={this.state.orderBy}
                                            onRequestSort={() => {}}
                                            rows ={this.state.columns} />
                                                <TableBody>
                                                    {this.state.current_rows}
                                                </TableBody>
                                    </Table>
                                </div>
                            </Paper>
                        </div>
                    </div>
                    { stock_type_rows.length > 0 && source_names.length > 0 && master_products.length > 0 &&
                        <Fab onClick={this.newReport} color="primary" aria-label="Add" className={classes.fab}>
                            <Icon>add</Icon>
                        </Fab>
                    }
                    <VerifyPhysicalStockDialog open={new_dialog_open} source_names={source_names} stock_type_rows={stock_type_rows} master_products={master_products} close={() => this.setState({new_dialog_open: false})} save={() => selected_source && selected_stock_type && startdate && this.fetchData()} {...this.props}/>
                </div>
        );
    }
}

class Details extends Component {

    render(){
      const {index, product, actual_qty, physical_qty, original_difference, current_stock} = this.props;
        return (
            <TableRow key={index}>
                <TableCell component="th" scope="row" align="center" padding='none'>
                    <Typography>{index}</Typography>
                </TableCell>
                <TableCell component="th" scope="row" align="center" padding='none'>
                    <ListItemText  primary={product.name} secondary={product.display_name || "-"}/>
                    {/* <Typography variant="subtitle2">{product.display_name || product.name}</Typography> */}
                </TableCell>
                {/* <TableCell align="center"  padding='none'>{}</TableCell> */}
                <TableCell align="right"  padding='none'><Typography variant="subtitle2">{actual_qty}</Typography></TableCell>
                <TableCell align="right"  padding='none'><Typography variant="subtitle2">{physical_qty}</Typography></TableCell>
                <TableCell align="right"  padding='none'><Typography variant="subtitle2" color={original_difference !== 0 ? 'secondary': 'textSecondary'}>{original_difference}</Typography></TableCell>
                <TableCell align="right"  padding='none'><Typography variant="subtitle2" color={current_stock - physical_qty !== 0 ? 'secondary': 'textSecondary'}>{current_stock - physical_qty}</Typography></TableCell>
            </TableRow>
        );
    }
}

export default withStyles(styles)(VerifyPhysicalStockReport);